import request from '@/config/axios'

export interface ScenicSelfConfigVO {
  /** 自营主景区 ID */
  scenicId?: number
  /** 自营主景区名称 */
  spotName?: string
}

/**
 * 景区自营门户配置
 * 移动端自营模式（景区首页 / 购票页 / 票型介绍页）的主景区指定，
 * 落库于 infra_config：scenic.app.self.scenicId
 */
export const ScenicSelfConfigApi = {
  get: () => request.get<ScenicSelfConfigVO>({ url: '/scenic/self-config/get' }),
  save: (scenicId: number) =>
    request.post<boolean>({ url: '/scenic/self-config/save', data: { scenicId } })
}
